import React, { useState } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../helpers/frontend";
import { useNavigate } from "react-router-dom";
import { ImagePath } from "../config/apiEndPoints";
import { callApi } from "../config/apiCall";
import { toast } from "react-toastify";

const TableComponent = ({ tableHeader, pdfView, reminder, externalLink, pdfDownload, dataSource, dataKeys, onEdit, handleDelete, onView, historyLink }) => {
  const plansData = useSelector((state) => state.commenData.allPlans)
  const navigate = useNavigate()
  const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const [reminderSended, setReminder] = useState({})
  // //console.log("plansData" ,plansData);
  const sendReminder = async (item, index) => {
    // //console.log("plansData", item);
    try {
      let response = await callApi(`/super-admin/payments/notification/${item?.invoice?.id}`, "get", "", details?.token)
      // //console.log(response, "<<<<<<<<<Asdf");
      if (response.success) {
        toast.success(response?.message)
        setReminder((prev) => ({
          ...prev,
          [index]: true
        }))
      }

    } catch (error) {
      // //console.log(error);
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message || error.message || "Server Error")
      }
    }
  }
  return (
    <React.Fragment>
      <table className="table datatable">
        <thead className="thead-light">
          <tr>
            <th>Sr. No.</th>
            {
              tableHeader?.map((tableHead, index) => {
                return (
                  <th key={index}>{tableHead}</th>
                )
              })
            }
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {dataSource?.map((item, rowIndex) => (
            <tr key={rowIndex}>
              <td>{rowIndex + 1}</td>
              {dataKeys?.map((key, colIndex) => {
                let content;
                switch (key) {
                  case "status":
                    content = (
                      <span className={`badge badge-${item[key] == "Active" ? "success" : item[key] == "Hold" ? "warning" : "danger"} d-inline-flex align-items-center badge-xs`}>
                        <i className="ti ti-point-filled me-1"></i>
                        {item[key] !== undefined && item[key] !== '' ? item[key] : '-'}
                      </span>
                    );
                    break;

                  case "due_date":
                    content = (
                      <span>
                        {item?.invoice?.due_date !== undefined && item?.invoice?.due_date !== '' ? item?.invoice?.due_date : 'NA'}
                      </span>
                    );
                    break;

                  case "payment_status":
                    const pStatus = item?.invoice?.status;
                    content = (
                      <span style={{textTransform:"capitalize"}} className={`badge badge-${pStatus == "due" ? "purple" : pStatus == "paid" ? "success" : pStatus == "unpaid" ? "danger" : "warning"} d-inline-flex align-items-center badge-xs`}>
                        <i className="ti ti-point-filled me-1"></i>
                        {pStatus !== undefined && pStatus !== '' ? pStatus : '-'}
                      </span>
                    );
                    break;

                  case "services":
                    if (item["services"]) {
                      content = (
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="p-0 m-0 text-capitalize">
                            {item[key]?.map((item) => item?.name).join("/")}
                          </p>
                        </div>
                      );
                    }
                    break;

                  case "service_type":
                    if (item['current_plan']) {
                      content = (
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="p-0 m-0 text-capitalize">
                            {item['current_plan']?.services?.map((item) => item?.name).join("/")}
                          </p>
                        </div>
                      );
                    }
                    break;

                  case "plan_id":
                    const findPlan = plansData?.data?.find((planItem) => planItem?.id == item[key]) || {};
                    content = (
                      <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 me-2">
                          {findPlan?.name}-({findPlan?.duration})
                        </p>
                      </div>
                    );
                    break;
                  case "plan_dates":
                    content = (
                      <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0 me-2">
                          {formatDate(item?.current_plan?.start_date)} - {formatDate(item?.current_plan?.end_date)}
                        </p>
                      </div>
                    );
                    break;

                  default:
                    content =
                      key === "invoice" ? (
                        item?.invoice?.invoice_no
                      ) : (
                        <>
                          {["price", "total_price"].includes(key) && "₹"}
                          {key === "company_name" ? (
                            <div className="d-flex align-items-center gap-2">
                              <span className="avatar">
                                <img
                                  src={item["company_logo"] ? ImagePath + item["company_logo"] : "/assets/img/company/company-02.svg"}
                                  className="img-fluid rounded-circle border"
                                  alt="logo"
                                />
                              </span>
                              {item[key] !== undefined && item[key] !== '' ? item[key] : '-'}
                            </div>
                          ) : (
                            item[key] !== undefined && item[key] !== '' ? item[key] : key == "p_name" ?
                             item["plan_name"]  : '-'
                          )}
                          {/* {
                            key == "p_name" ?
                             item["plan_name"]  : '-'
                          } */}
                          {key === "plan_name" && item?.plan_name?.toLowerCase() === "basic" && (
                            <a onClick={() => pdfView(item, "upgrade")} className="ml-2 badge badge-purple badge-xs">Upgrade</a>
                          )}
                        </>
                      );
                }

                return <td key={colIndex}>{content}</td>;
              })}

              <td>
                <div className="action-icon d-inline-flex align-items-center">
                  {
                    historyLink &&
                    <a onClick={() => {
                      navigate(historyLink, { state: { data: item["id"] } })
                    }} className="me-2" title='Payment history' >
                      <i className="ti ti-history"></i>
                    </a>
                  }
                  {
                    onView &&
                    <a className="me-2"
                      onClick={() => { onView(item, "view") }}
                      title='View Details'>
                      <i className="ti ti-eye"></i>
                    </a>
                  }
                  {
                    pdfView &&
                    <a className="me-2"
                      onClick={() => { pdfView(item, "pdfView") }}
                      title='View Invoice'>
                      <i className="ti ti-file-text"></i>
                    </a>
                  }
                  {
                    pdfDownload &&
                    <a className="me-2"
                      onClick={() => { pdfDownload(item, "pdfDownload") }}
                      title='Download Invoice'>
                      <i className="ti ti-download"></i>
                    </a>
                  }
                  {
                    onEdit &&
                    <a className="me-2"
                      title="Edit"
                      onClick={() => { 
                        if(item?.invoice?.status == "paid"){
                          return
                        }
                        onEdit(item, "edit")
                       }}
                    >
                      <i className={`ti ti-edit ${item?.invoice?.status == "paid" ? "disable-Color":""} `}></i>
                    </a>
                  }
                  {/*"disable-Color" <a href="#" className="me-2" title='Edit' ><i className="ti ti-edit"></i></a> */}
                  {
                    handleDelete &&
                    <div onClick={() => { handleDelete(item, "delete") }} ><i className="ti ti-trash"></i></div>
                  }
                  {
                    externalLink &&
                    <a title="Redirect Url" style={{ cursor: "pointer" }} href={`${externalLink}?dbid=${item?.id}&company_id=${item.company_id}`} target="_blank" >
                      <i className="ti ti-external-link fs-15"></i>
                    </a>
                  }
                  {
                    reminder &&
                    <a title="Send Payment Reminder" onClick={() => {
                      if(item?.invoice?.status == "paid"){
                        return
                      }
                      sendReminder(item ,rowIndex)
                    }} style={{ cursor: "pointer" }} >
                      {
                        reminderSended[rowIndex] ?
                          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" >
                            <path d="M15.5723 14C15.6893 14.2027 15.8576 14.371 16.0603 14.488C16.263 14.605 16.4929 14.6666 16.7269 14.6666C16.961 14.6666 17.1909 14.605 17.3936 14.488C17.5963 14.371 17.7646 14.2027 17.8816 14" stroke="#047EFF" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.0041 1.54265C17.4025 1.3399 16.7612 1.28329 16.1333 1.3775C15.5054 1.47172 14.9089 1.71405 14.3932 2.08446C13.8776 2.45486 13.4575 2.94271 13.1677 3.50765C12.8779 4.07259 12.7268 4.6984 12.7268 5.33332C12.7268 8.33265 11.7861 9.30399 10.9001 10.218C10.8132 10.3135 10.7559 10.4323 10.7352 10.5598C10.7145 10.6874 10.7313 10.8182 10.7835 10.9363C10.8358 11.0545 10.9213 11.1549 11.0296 11.2254C11.1378 11.2959 11.2643 11.3334 11.3935 11.3333H22.0601C22.1893 11.3334 22.3158 11.2959 22.424 11.2254C22.5323 11.1549 22.6178 11.0545 22.6701 10.9363C22.7223 10.8182 22.7391 10.6874 22.7184 10.5598C22.6977 10.4323 22.6404 10.3135 22.5535 10.218C22.4163 10.0767 22.2861 9.92874 22.1635 9.77465" stroke="#047EFF" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M23.2402 2.43262L19.7839 6.23455L18.2129 4.5064" stroke="#047EFF" stroke-linecap="round" stroke-linejoin="round" />
                            <g filter="url(#filter0_d_2346_24597)">
                              <rect x="2.72656" y="16" width="28" height="14" rx="1" fill="#047EFF" shape-rendering="crispEdges" />
                              <path d="M11.4219 24.5352C11.4219 24.418 11.4036 24.3138 11.3672 24.2227C11.3333 24.1315 11.2721 24.0482 11.1836 23.9727C11.0951 23.8971 10.9701 23.8242 10.8086 23.7539C10.6497 23.681 10.4466 23.6068 10.1992 23.5312C9.92839 23.4479 9.67839 23.3555 9.44922 23.2539C9.22266 23.1497 9.02474 23.0299 8.85547 22.8945C8.6862 22.7565 8.55469 22.599 8.46094 22.4219C8.36719 22.2422 8.32031 22.0352 8.32031 21.8008C8.32031 21.569 8.36849 21.3581 8.46484 21.168C8.5638 20.9779 8.70312 20.8138 8.88281 20.6758C9.0651 20.5352 9.27995 20.4271 9.52734 20.3516C9.77474 20.2734 10.0482 20.2344 10.3477 20.2344C10.7695 20.2344 11.1328 20.3125 11.4375 20.4688C11.7448 20.625 11.9805 20.8346 12.1445 21.0977C12.3112 21.3607 12.3945 21.651 12.3945 21.9688H11.4219C11.4219 21.7812 11.3815 21.6159 11.3008 21.4727C11.2227 21.3268 11.1029 21.2122 10.9414 21.1289C10.7826 21.0456 10.5807 21.0039 10.3359 21.0039C10.1042 21.0039 9.91146 21.0391 9.75781 21.1094C9.60417 21.1797 9.48958 21.2747 9.41406 21.3945C9.33854 21.5143 9.30078 21.6497 9.30078 21.8008C9.30078 21.9076 9.32552 22.0052 9.375 22.0938C9.42448 22.1797 9.5 22.2604 9.60156 22.3359C9.70312 22.4089 9.83073 22.4779 9.98438 22.543C10.138 22.6081 10.319 22.6706 10.5273 22.7305C10.8424 22.8242 11.1172 22.9284 11.3516 23.043C11.5859 23.1549 11.7812 23.2826 11.9375 23.4258C12.0938 23.569 12.2109 23.7318 12.2891 23.9141C12.3672 24.0938 12.4062 24.2982 12.4062 24.5273C12.4062 24.7669 12.3581 24.9831 12.2617 25.1758C12.1654 25.3659 12.0273 25.5286 11.8477 25.6641C11.6706 25.7969 11.457 25.8997 11.207 25.9727C10.9596 26.043 10.6836 26.0781 10.3789 26.0781C10.1055 26.0781 9.83594 26.0417 9.57031 25.9688C9.30729 25.8958 9.06771 25.7852 8.85156 25.6367C8.63542 25.4857 8.46354 25.2982 8.33594 25.0742C8.20833 24.8477 8.14453 24.5833 8.14453 24.2812H9.125C9.125 24.4661 9.15625 24.6237 9.21875 24.7539C9.28385 24.8841 9.3737 24.9909 9.48828 25.0742C9.60286 25.1549 9.73568 25.2148 9.88672 25.2539C10.0404 25.293 10.2044 25.3125 10.3789 25.3125C10.6081 25.3125 10.7995 25.2799 10.9531 25.2148C11.1094 25.1497 11.2266 25.0586 11.3047 24.9414C11.3828 24.8242 11.4219 24.6888 11.4219 24.5352ZM15.543 26.0781C15.2305 26.0781 14.9479 26.0273 14.6953 25.9258C14.4453 25.8216 14.2318 25.6771 14.0547 25.4922C13.8802 25.3073 13.7461 25.0898 13.6523 24.8398C13.5586 24.5898 13.5117 24.3203 13.5117 24.0312V23.875C13.5117 23.5443 13.5599 23.2448 13.6562 22.9766C13.7526 22.7083 13.8867 22.4792 14.0586 22.2891C14.2305 22.0964 14.4336 21.9492 14.668 21.8477C14.9023 21.7461 15.1562 21.6953 15.4297 21.6953C15.7318 21.6953 15.9961 21.7461 16.2227 21.8477C16.4492 21.9492 16.6367 22.0924 16.7852 22.2773C16.9362 22.4596 17.0482 22.6771 17.1211 22.9297C17.1966 23.1823 17.2344 23.4609 17.2344 23.7656V24.168H13.9688V23.4922H16.3047V23.418C16.2995 23.2487 16.2656 23.0898 16.2031 22.9414C16.1432 22.793 16.0508 22.6732 15.9258 22.582C15.8008 22.4909 15.6341 22.4453 15.4258 22.4453C15.2695 22.4453 15.1302 22.4792 15.0078 22.5469C14.888 22.612 14.7878 22.707 14.707 22.832C14.6263 22.957 14.5638 23.1081 14.5195 23.2852C14.4779 23.4596 14.457 23.6562 14.457 23.875V24.0312C14.457 24.2161 14.4818 24.388 14.5312 24.5469C14.5833 24.7031 14.6589 24.8398 14.7578 24.957C14.8568 25.0742 14.9766 25.1667 15.1172 25.2344C15.2578 25.2995 15.418 25.332 15.5977 25.332C15.8242 25.332 16.026 25.2865 16.2031 25.1953C16.3802 25.1042 16.5339 24.9753 16.6641 24.8086L17.1602 25.2891C17.069 25.4219 16.9505 25.5495 16.8047 25.6719C16.6589 25.7917 16.4805 25.8893 16.2695 25.9648C16.0612 26.0404 15.819 26.0781 15.543 26.0781ZM19.4023 22.6758V26H18.4609V21.7734H19.3477L19.4023 22.6758ZM19.2344 23.7305L18.9297 23.7266C18.9323 23.4271 18.974 23.1523 19.0547 22.9023C19.138 22.6523 19.2526 22.4375 19.3984 22.2578C19.5469 22.0781 19.724 21.9401 19.9297 21.8438C20.1354 21.7448 20.3646 21.6953 20.6172 21.6953C20.8203 21.6953 21.0039 21.724 21.168 21.7812C21.3346 21.8359 21.4766 21.9258 21.5938 22.0508C21.7135 22.1758 21.8047 22.3385 21.8672 22.5391C21.9297 22.737 21.9609 22.9805 21.9609 23.2695V26H21.0156V23.2656C21.0156 23.0625 20.9857 22.9023 20.9258 22.7852C20.8685 22.6654 20.7839 22.5807 20.6719 22.5312C20.5625 22.4792 20.4258 22.4531 20.2617 22.4531C20.1003 22.4531 19.9557 22.487 19.8281 22.5547C19.7005 22.6224 19.5924 22.7148 19.5039 22.832C19.418 22.9492 19.3516 23.0846 19.3047 23.2383C19.2578 23.3919 19.2344 23.556 19.2344 23.7305ZM25.3594 21.7734V22.4609H22.9766V21.7734H25.3594ZM23.6641 20.7383H24.6055V24.832C24.6055 24.9622 24.6237 25.0625 24.6602 25.1328C24.6992 25.2005 24.7526 25.2461 24.8203 25.2695C24.888 25.293 24.9674 25.3047 25.0586 25.3047C25.1237 25.3047 25.1862 25.3008 25.2461 25.293C25.306 25.2852 25.3542 25.2773 25.3906 25.2695L25.3945 25.9883C25.3164 26.0117 25.2253 26.0326 25.1211 26.0508C25.0195 26.069 24.9023 26.0781 24.7695 26.0781C24.5534 26.0781 24.362 26.0404 24.1953 25.9648C24.0286 25.8867 23.8984 25.7604 23.8047 25.5859C23.7109 25.4115 23.6641 25.1797 23.6641 24.8906V20.7383Z" fill="white" />
                            </g>
                            <defs>
                              <filter id="filter0_d_2346_24597" x="0.726562" y="15" width="32" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="1" />
                                <feGaussianBlur stdDeviation="1" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2346_24597" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2346_24597" result="shape" />
                              </filter>
                            </defs>
                          </svg>:
                          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.57227 14C7.68929 14.2027 7.85761 14.371 8.0603 14.488C8.26298 14.605 8.4929 14.6666 8.72693 14.6666C8.96097 14.6666 9.19088 14.605 9.39357 14.488C9.59626 14.371 9.76457 14.2027 9.8816 14" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.0041 1.54265C9.40246 1.3399 8.76115 1.28329 8.13326 1.3775C7.50536 1.47172 6.90892 1.71405 6.39324 2.08446C5.87756 2.45486 5.45746 2.94271 5.16769 3.50765C4.87791 4.07259 4.72679 4.6984 4.7268 5.33332C4.7268 8.33265 3.78613 9.30399 2.90013 10.218C2.81318 10.3135 2.75587 10.4323 2.73517 10.5598C2.71448 10.6874 2.73128 10.8182 2.78354 10.9363C2.8358 11.0545 2.92127 11.1549 3.02956 11.2254C3.13784 11.2959 3.26427 11.3334 3.39347 11.3333H14.0601C14.1893 11.3334 14.3158 11.2959 14.424 11.2254C14.5323 11.1549 14.6178 11.0545 14.6701 10.9363C14.7223 10.8182 14.7391 10.6874 14.7184 10.5598C14.6977 10.4323 14.6404 10.3135 14.5535 10.218C14.4163 10.0767 14.2861 9.92874 14.1635 9.77465" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.7266 7.33301C13.8311 7.33301 14.7266 6.43758 14.7266 5.33301C14.7266 4.22844 13.8311 3.33301 12.7266 3.33301C11.622 3.33301 10.7266 4.22844 10.7266 5.33301C10.7266 6.43758 11.622 7.33301 12.7266 7.33301Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                      }
                    </a>
                  }
                </div>
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </React.Fragment>
  );
};

export default TableComponent;
